import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="not-found">
      Page Not Found - 404
      <Link to="/">
        Back
      </Link>
    </div>
  );
};

export default NotFound;
